import React, { useEffect, useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import {
  Stack,
  Button,
  TextField,
  Grid,
  Box,
  Tab,
  MenuItem,
  Chip,
  Card,
  Autocomplete
} from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import DataGrid, {
  Scrolling,
  Paging,
  HeaderFilter,
  Pager,
  SearchPanel,
  GroupPanel,
  Column,
  ColumnChooser,
  ColumnFixing
} from 'devextreme-react/data-grid';

import { CustomInfosForm, CustomGrid } from '../../../../assets/style/globalStyle';
import configAxios from '../../../../services/configAxios';
import MoreMenu from '../../../components/multiplesComponents/MoreMenu';
import Iconify from '../../../../@core/theme/Iconify';
import AddEditLeadsCatalog from './addEditLeadsCatalog';
import ShowDocuments from '../../../components/multiplesComponents/ShowDocuments';
import { DropzoneArea } from 'mui-file-dropzone';

const allowedPageSizes = [5, 10, 20, 30];

const FormConfigPanel = () => {
  const [tab, setTab] = useState('1');
  const [params, setParams] = useState({});
  const [acquisitions, setAcquisitions] = useState([]);
  const [losses, setLosses] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [tags, setTags] = useState([]);
  const [actions, setActions] = useState([]);
  const [infosBroker, setInfosBroker] = useState([]);
  const [infosVend, setInfosVend] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [dialogType, setDialogType] = useState('');
  const [infosItemEdit, setInfosItemEdit] = useState({});
  const [uploadingPrivacyPolicy, setUploadingPrivacyPolicy] = useState(false);
  const [openModalPreviewPrivacyPolicy, setOpenModalPreviewPrivacyPolicy] = useState(false);
  const privacyPolicyKey = useRef(0);

  useEffect(() => {
    getParams();
    getAcquisitions();
    getLosses();
    getStatusLeads();
    getTags();
    getActions();
    getBrokers();
  }, []);

  function getParams() {
    configAxios
      .get('/leads/getLeadsParams')
      .then((response) => {
        const data = response.data || {};
        setParams(data);
        if (data.id_broker_padrao) {
          loadVendors(data.id_broker_padrao);
        }
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os parâmetros, tente novamente!',
          'Atenção'
        );
      });
  }

  function getBrokers() {
    configAxios
      .post('/brokers/listBrokerLabelUsers')
      .then((response) =>
        setInfosBroker((response.data || []).filter((item) => item.id !== '' && item.id != null))
      )
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as corretoras, tente novamente!',
          'Atenção'
        );
      });
  }

  function loadVendors(id_broker) {
    if (!id_broker) {
      setInfosVend([]);
      return;
    }
    configAxios
      .get(`/brokers/listVendLabel/${id_broker}`)
      .then((response) =>
        setInfosVend((response.data || []).filter((item) => item.id !== '' && item.id != null))
      )
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os vendedores, tente novamente!',
          'Atenção'
        );
      });
  }

  function getAcquisitions() {
    configAxios
      .get('/leads/getAcquisitionsAdmin')
      .then((response) => {
        setAcquisitions(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os canais, tente novamente!',
          'Atenção'
        );
      });
  }

  function getLosses() {
    configAxios
      .get('/leads/getLosses')
      .then((response) => {
        setLosses(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os motivos, tente novamente!',
          'Atenção'
        );
      });
  }

  function getStatusLeads() {
    configAxios
      .get('/leads/getStatusLeads')
      .then((response) => {
        setStatuses(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os status, tente novamente!',
          'Atenção'
        );
      });
  }

  function getTags() {
    configAxios
      .get('/leads/getTags')
      .then((response) => {
        setTags(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as tags, tente novamente!',
          'Atenção'
        );
      });
  }

  function getActions() {
    configAxios
      .get('/leads/getActions')
      .then((response) => {
        setActions(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as ações, tente novamente!',
          'Atenção'
        );
      });
  }

  function HandleInputChange(event) {
    setParams({ ...params, [event.target.name]: event.target.value });
  }

  function HandlePrivacyPolicyUpload(files) {
    if (!files || !files.length) {
      return;
    }

    const file = files[0];
    const fileName = String(file.name || '').toLowerCase();

    if (!fileName.endsWith('.pdf')) {
      NotificationManager.warning('Apenas arquivos PDF são permitidos.', 'Atenção');
      privacyPolicyKey.current += 1;
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    setUploadingPrivacyPolicy(true);
    configAxios
      .post('/leads/uploadPrivacyPolicy', formData)
      .then((response) => {
        const url = response.data?.url || '';
        setParams({ ...params, politica_privacidade: url });
        NotificationManager.success('Política de privacidade atualizada com sucesso!', 'Sucesso');
        privacyPolicyKey.current += 1;
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para enviar o PDF, tente novamente!',
          'Atenção'
        );
        privacyPolicyKey.current += 1;
      })
      .finally(() => {
        setUploadingPrivacyPolicy(false);
      });
  }

  function HandleSubmit(event) {
    event.preventDefault();
    const payload = { ...params };
    payload.vende_pf = payload.vende_pf === 'S' ? 'S' : 'N';
    payload.vende_pj = payload.vende_pj === 'S' ? 'S' : 'N';
    payload.mostra_acomodacao = payload.mostra_acomodacao === 'S' ? 'S' : 'N';
    payload.mostra_copart = payload.mostra_copart === 'S' ? 'S' : 'N';
    payload.mostra_previsao_inicio = payload.mostra_previsao_inicio === 'S' ? 'S' : 'N';
    payload.mostra_valor_esperado = payload.mostra_valor_esperado === 'S' ? 'S' : 'N';
    payload.id_broker_padrao = payload.id_broker_padrao || null;
    payload.id_user_padrao = payload.id_user_padrao || null;

    configAxios
      .post('/leads/updateLeadsParams', payload)
      .then(() => {
        NotificationManager.success('Parâmetros salvos com sucesso!', 'Sucesso');
        getParams();
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function CatalogModal(type, item) {
    setDialogType(type);
    setInfosItemEdit(item || {});
    setOpenModal(true);
  }

  function functionGrid() {
    if (dialogType === 'acquisition') {
      getAcquisitions();
    } else if (dialogType === 'loss') {
      getLosses();
    } else if (dialogType === 'status') {
      getStatusLeads();
    } else if (dialogType === 'tag') {
      getTags();
    } else if (dialogType === 'action') {
      getActions();
    }
  }

  function ActionsButtons(items) {
    const infos = [];
    infos.push(items.data.data);
    return infos.map((item) => (
      <MoreMenu
        key={item[items.idKey]}
        infos={{
          id: item[items.idKey],
          deleteRouter: items.deleteRouter,
          deleteItem: items.deleteItem,
          functionGrid: items.reload,
          otherInfos: item,
          functionModal: () => CatalogModal(items.type, item)
        }}
      />
    ));
  }

  ActionsButtons.propTypes = {
    data: PropTypes.object,
    type: PropTypes.string,
    idKey: PropTypes.string,
    deleteRouter: PropTypes.string,
    deleteItem: PropTypes.string,
    reload: PropTypes.func
  };

  return (
    <Box sx={{ width: '100%' }}>
      <AddEditLeadsCatalog
        openModal={openModal}
        setOpenModal={setOpenModal}
        type={dialogType}
        infosItemEdit={infosItemEdit}
        functionGrid={functionGrid}
      />
      <ShowDocuments
        openModal={openModalPreviewPrivacyPolicy}
        url={
          params.politica_privacidade
            ? `${params.politica_privacidade}?${privacyPolicyKey.current}`
            : null
        }
        nome="Política de privacidade"
        setOpenModal={setOpenModalPreviewPrivacyPolicy}
      />
      <CustomInfosForm>
        Configure o formulário de captação e os cadastros do CRM de leads
      </CustomInfosForm>
      <TabContext value={tab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 1 }}>
          <TabList onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto">
            <Tab label="Formulário" value="1" />
            <Tab label="Canais" value="2" />
            <Tab label="Motivos da perda" value="3" sx={{ textTransform: 'none' }} />
            <Tab label="Status" value="4" />
            <Tab label="Tags" value="5" />
            <Tab label="Ações" value="6" />
          </TabList>
        </Box>

        <TabPanel value="1" sx={{ px: 0 }}>
          <form onSubmit={HandleSubmit}>
            <Box sx={{ width: '100%', border: 1, borderColor: 'grey.200', p: 1 }}>
              <CustomInfosForm>Campos obrigatórios possuem asterisco (*)</CustomInfosForm>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    variant="outlined"
                    name="titulo_formulario"
                    label="Título do formulário"
                    fullWidth
                    size="small"
                    value={params.titulo_formulario || ''}
                    onChange={(event) => HandleInputChange(event)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    variant="outlined"
                    name="subtitulo_formulario"
                    label="Subtítulo do formulário"
                    fullWidth
                    size="small"
                    value={params.subtitulo_formulario || ''}
                    onChange={(event) => HandleInputChange(event)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    variant="outlined"
                    name="titulo_encerramento"
                    label="Título de encerramento"
                    fullWidth
                    size="small"
                    value={params.titulo_encerramento || ''}
                    onChange={(event) => HandleInputChange(event)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    variant="outlined"
                    name="subtitulo_encerramento"
                    label="Subtítulo de encerramento"
                    fullWidth
                    size="small"
                    value={params.subtitulo_encerramento || ''}
                    onChange={(event) => HandleInputChange(event)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    name="emails_notificacao"
                    label="E-mails de notificação (separados por ;)"
                    fullWidth
                    size="small"
                    value={params.emails_notificacao || ''}
                    onChange={(event) => HandleInputChange(event)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInfosForm sx={{ mb: 1 }}>Política de privacidade</CustomInfosForm>
                  {params.politica_privacidade && (
                    <Stack direction="row" justifyContent="end" sx={{ mb: 2 }}>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => setOpenModalPreviewPrivacyPolicy(true)}
                        sx={{ textTransform: 'none' }}
                        startIcon={<Iconify icon="eva:printer-outline" />}>
                        Pré visualizar
                      </Button>
                    </Stack>
                  )}
                  <Box
                    sx={{
                      '& > div': {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: 220
                      }
                    }}>
                    <DropzoneArea
                      key={privacyPolicyKey.current}
                      acceptedFiles={['application/pdf', '.pdf']}
                      maxFileSize={10000000}
                      onChange={HandlePrivacyPolicyUpload}
                      dropzoneText={
                        uploadingPrivacyPolicy
                          ? 'Enviando PDF...'
                          : params.politica_privacidade
                          ? 'PDF enviado. Arraste outro arquivo para substituir'
                          : 'Arraste o PDF ou clique para selecionar'
                      }
                      fullWidth
                      showAlerts={false}
                      filesLimit={1}
                      showPreviewsInDropzone={false}
                      disabled={uploadingPrivacyPolicy}
                      getFileLimitExceedMessage={() =>
                        NotificationManager.warning('Apenas 1 arquivo PDF por vez', 'Atenção')
                      }
                    />
                  </Box>
                  <CustomInfosForm sx={{ mt: 1 }}>
                    Apenas arquivos .pdf. O documento será salvo como policita_privacidade.pdf e
                    exibido no formulário público.
                  </CustomInfosForm>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    options={infosBroker}
                    value={
                      infosBroker.find(
                        (item) => String(item.id) === String(params.id_broker_padrao)
                      ) || null
                    }
                    getOptionLabel={(option) => option.label || ''}
                    isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                    onChange={(event, value) => {
                      setParams({
                        ...params,
                        id_broker_padrao: value ? value.id : null,
                        id_user_padrao: null
                      });
                      loadVendors(value ? value.id : null);
                    }}
                    renderInput={(paramsInput) => (
                      <TextField
                        {...paramsInput}
                        label="Corretora padrão"
                        size="small"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    options={infosVend}
                    value={
                      infosVend.find((item) => String(item.id) === String(params.id_user_padrao)) ||
                      null
                    }
                    getOptionLabel={(option) => option.label || ''}
                    isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                    onChange={(event, value) =>
                      setParams({ ...params, id_user_padrao: value ? value.id : null })
                    }
                    renderInput={(paramsInput) => (
                      <TextField
                        {...paramsInput}
                        label="Vendedor padrão"
                        size="small"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    variant="outlined"
                    select
                    name="vende_pf"
                    label="Vende PF"
                    fullWidth
                    size="small"
                    value={params.vende_pf === 'S' ? 'S' : 'N'}
                    onChange={(event) => HandleInputChange(event)}>
                    <MenuItem value="S">Sim</MenuItem>
                    <MenuItem value="N">Não</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    variant="outlined"
                    select
                    name="vende_pj"
                    label="Vende PJ"
                    fullWidth
                    size="small"
                    value={params.vende_pj === 'S' ? 'S' : 'N'}
                    onChange={(event) => HandleInputChange(event)}>
                    <MenuItem value="S">Sim</MenuItem>
                    <MenuItem value="N">Não</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    variant="outlined"
                    select
                    name="mostra_acomodacao"
                    label="Mostra acomodação"
                    fullWidth
                    size="small"
                    value={params.mostra_acomodacao === 'S' ? 'S' : 'N'}
                    onChange={(event) => HandleInputChange(event)}>
                    <MenuItem value="S">Sim</MenuItem>
                    <MenuItem value="N">Não</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    variant="outlined"
                    select
                    name="mostra_copart"
                    label="Mostra coparticipação"
                    fullWidth
                    size="small"
                    value={params.mostra_copart === 'S' ? 'S' : 'N'}
                    onChange={(event) => HandleInputChange(event)}>
                    <MenuItem value="S">Sim</MenuItem>
                    <MenuItem value="N">Não</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    variant="outlined"
                    select
                    name="mostra_previsao_inicio"
                    label="Mostra previsão de início"
                    fullWidth
                    size="small"
                    value={params.mostra_previsao_inicio === 'S' ? 'S' : 'N'}
                    onChange={(event) => HandleInputChange(event)}>
                    <MenuItem value="S">Sim</MenuItem>
                    <MenuItem value="N">Não</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    variant="outlined"
                    select
                    name="mostra_valor_esperado"
                    label="Mostra valor esperado"
                    fullWidth
                    size="small"
                    value={params.mostra_valor_esperado === 'S' ? 'S' : 'N'}
                    onChange={(event) => HandleInputChange(event)}>
                    <MenuItem value="S">Sim</MenuItem>
                    <MenuItem value="N">Não</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
            </Box>
            <Stack direction="row" justifyContent="end" sx={{ mr: 2.5, mt: 2 }}>
              <Button
                type="submit"
                variant="contained"
                size="medium"
                color="success"
                startIcon={<Iconify icon="eva:save-fill" />}
                sx={{ mr: 2 }}>
                Atualizar
              </Button>
              <Button
                variant="contained"
                color="error"
                component={RouterLink}
                to="/app/dashboard"
                startIcon={<Iconify icon="eva:close-circle-fill" />}>
                Cancelar
              </Button>
            </Stack>
          </form>
        </TabPanel>

        <TabPanel value="2" sx={{ px: 0 }}>
          <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
            <Button
              variant="contained"
              onClick={() => CatalogModal('acquisition', { canal: '' })}
              sx={{ mr: 1 }}
              startIcon={<Iconify icon="eva:plus-fill" />}>
              Novo
            </Button>
            {!isMobile && (
              <Button
                variant="outlined"
                onClick={getAcquisitions}
                sx={{ ml: 1 }}
                startIcon={<Iconify icon="eva:refresh-outline" />}>
                Atualizar
              </Button>
            )}
          </Stack>
          <Card>
            <CustomGrid>
              <DataGrid
                dataSource={acquisitions}
                showBorders={true}
                remoteOperations={true}
                wordWrapEnabled={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                noDataText={'Não há canais cadastrados'}>
                <Column dataField="id_acquisition" caption="ID" width={70} />
                <Column dataField="canal" caption="Canal" />
                <Column
                  dataField="Ações"
                  width={100}
                  allowSorting={false}
                  cellRender={(data) => (
                    <ActionsButtons
                      data={data}
                      type="acquisition"
                      idKey="id_acquisition"
                      deleteRouter="/leads/deleteAcquisition"
                      deleteItem="o canal"
                      reload={getAcquisitions}
                    />
                  )}
                />
                <SearchPanel visible={true} width={240} placeholder="Procurar..." />
                {!isMobile && (
                  <GroupPanel
                    visible={true}
                    emptyPanelText="Arraste as colunas aqui para agrupar"
                  />
                )}
                <Scrolling rowRenderingMode="virtual"></Scrolling>
                <Paging defaultPageSize={10} />
                <Pager
                  visible={true}
                  allowedPageSizes={allowedPageSizes}
                  showPageSizeSelector={true}
                  showInfo={true}
                  showNavigationButtons={true}
                />
                <ColumnChooser
                  enabled={true}
                  title={'Escolher uma coluna'}
                  emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                />
                <ColumnFixing enabled={true} />
                <HeaderFilter visible={true} allowSearch={true} />
              </DataGrid>
            </CustomGrid>
          </Card>
        </TabPanel>

        <TabPanel value="3" sx={{ px: 0 }}>
          <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
            <Button
              variant="contained"
              onClick={() => CatalogModal('loss', { motivo: '' })}
              sx={{ mr: 1 }}
              startIcon={<Iconify icon="eva:plus-fill" />}>
              Novo
            </Button>
            {!isMobile && (
              <Button
                variant="outlined"
                onClick={getLosses}
                sx={{ ml: 1 }}
                startIcon={<Iconify icon="eva:refresh-outline" />}>
                Atualizar
              </Button>
            )}
          </Stack>
          <Card>
            <CustomGrid>
              <DataGrid
                dataSource={losses}
                showBorders={true}
                remoteOperations={true}
                wordWrapEnabled={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                noDataText={'Não há motivos cadastrados'}>
                <Column dataField="id_loss" caption="ID" width={70} />
                <Column dataField="motivo" caption="Motivo" />
                <Column
                  dataField="Ações"
                  width={100}
                  allowSorting={false}
                  cellRender={(data) => (
                    <ActionsButtons
                      data={data}
                      type="loss"
                      idKey="id_loss"
                      deleteRouter="/leads/deleteLoss"
                      deleteItem="o motivo"
                      reload={getLosses}
                    />
                  )}
                />
                <SearchPanel visible={true} width={240} placeholder="Procurar..." />
                {!isMobile && (
                  <GroupPanel
                    visible={true}
                    emptyPanelText="Arraste as colunas aqui para agrupar"
                  />
                )}
                <Scrolling rowRenderingMode="virtual"></Scrolling>
                <Paging defaultPageSize={10} />
                <Pager
                  visible={true}
                  allowedPageSizes={allowedPageSizes}
                  showPageSizeSelector={true}
                  showInfo={true}
                  showNavigationButtons={true}
                />
                <ColumnChooser
                  enabled={true}
                  title={'Escolher uma coluna'}
                  emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                />
                <ColumnFixing enabled={true} />
                <HeaderFilter visible={true} allowSearch={true} />
              </DataGrid>
            </CustomGrid>
          </Card>
        </TabPanel>

        <TabPanel value="4" sx={{ px: 0 }}>
          <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
            <Button
              variant="contained"
              onClick={() => {
                let max = 0;
                statuses.forEach((item) => {
                  const n = Number(item.ordem) || 0;
                  if (n > max) max = n;
                });
                CatalogModal('status', {
                  status: '',
                  ordem: max + 1,
                  fundo: 'N',
                  perdido: 'N'
                });
              }}
              sx={{ mr: 1 }}
              startIcon={<Iconify icon="eva:plus-fill" />}>
              Novo
            </Button>
            {!isMobile && (
              <Button
                variant="outlined"
                onClick={getStatusLeads}
                sx={{ ml: 1 }}
                startIcon={<Iconify icon="eva:refresh-outline" />}>
                Atualizar
              </Button>
            )}
          </Stack>
          <Card>
            <CustomGrid>
              <DataGrid
                dataSource={statuses}
                showBorders={true}
                remoteOperations={true}
                wordWrapEnabled={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                noDataText={'Não há status cadastrados'}>
                <Column dataField="ordem" caption="Ordem" width={80} />
                <Column dataField="status" caption="Status" />
                <Column
                  dataField="fundo"
                  caption="Fundo"
                  cellRender={(d) => (
                    <Chip
                      color={d.data.fundo === 'S' ? 'success' : 'error'}
                      size="small"
                      variant="contained"
                      label={d.data.fundo === 'S' ? 'Sim' : 'Não'}
                    />
                  )}
                />
                <Column
                  dataField="perdido"
                  caption="Perdido"
                  cellRender={(d) => (
                    <Chip
                      color={d.data.perdido === 'S' ? 'success' : 'error'}
                      size="small"
                      variant="contained"
                      label={d.data.perdido === 'S' ? 'Sim' : 'Não'}
                    />
                  )}
                />
                <Column
                  dataField="Ações"
                  width={100}
                  allowSorting={false}
                  cellRender={(data) => (
                    <ActionsButtons
                      data={data}
                      type="status"
                      idKey="id_status_lead"
                      deleteRouter="/leads/deleteStatusLead"
                      deleteItem="o status"
                      reload={getStatusLeads}
                    />
                  )}
                />
                <SearchPanel visible={true} width={240} placeholder="Procurar..." />
                {!isMobile && (
                  <GroupPanel
                    visible={true}
                    emptyPanelText="Arraste as colunas aqui para agrupar"
                  />
                )}
                <Scrolling rowRenderingMode="virtual"></Scrolling>
                <Paging defaultPageSize={10} />
                <Pager
                  visible={true}
                  allowedPageSizes={allowedPageSizes}
                  showPageSizeSelector={true}
                  showInfo={true}
                  showNavigationButtons={true}
                />
                <ColumnChooser
                  enabled={true}
                  title={'Escolher uma coluna'}
                  emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                />
                <ColumnFixing enabled={true} />
                <HeaderFilter visible={true} allowSearch={true} />
              </DataGrid>
            </CustomGrid>
          </Card>
        </TabPanel>

        <TabPanel value="5" sx={{ px: 0 }}>
          <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
            <Button
              variant="contained"
              onClick={() => CatalogModal('tag', { tag: '', cor: '#0E4B4B' })}
              sx={{ mr: 1 }}
              startIcon={<Iconify icon="eva:plus-fill" />}>
              Novo
            </Button>
            {!isMobile && (
              <Button
                variant="outlined"
                onClick={getTags}
                sx={{ ml: 1 }}
                startIcon={<Iconify icon="eva:refresh-outline" />}>
                Atualizar
              </Button>
            )}
          </Stack>
          <Card>
            <CustomGrid>
              <DataGrid
                dataSource={tags}
                showBorders={true}
                remoteOperations={true}
                wordWrapEnabled={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                noDataText={'Não há tags cadastradas'}>
                <Column dataField="id_tag" caption="ID" width={70} />
                <Column dataField="tag" caption="Tag" />
                <Column
                  dataField="cor"
                  caption="Cor"
                  cellRender={(d) => (
                    <Chip
                      label={d.data.cor || '-'}
                      size="small"
                      sx={{ bgcolor: d.data.cor || '#ccc', color: '#fff' }}
                    />
                  )}
                />
                <Column
                  dataField="Ações"
                  width={100}
                  allowSorting={false}
                  cellRender={(data) => (
                    <ActionsButtons
                      data={data}
                      type="tag"
                      idKey="id_tag"
                      deleteRouter="/leads/deleteTag"
                      deleteItem="a tag"
                      reload={getTags}
                    />
                  )}
                />
                <SearchPanel visible={true} width={240} placeholder="Procurar..." />
                {!isMobile && (
                  <GroupPanel
                    visible={true}
                    emptyPanelText="Arraste as colunas aqui para agrupar"
                  />
                )}
                <Scrolling rowRenderingMode="virtual"></Scrolling>
                <Paging defaultPageSize={10} />
                <Pager
                  visible={true}
                  allowedPageSizes={allowedPageSizes}
                  showPageSizeSelector={true}
                  showInfo={true}
                  showNavigationButtons={true}
                />
                <ColumnChooser
                  enabled={true}
                  title={'Escolher uma coluna'}
                  emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                />
                <ColumnFixing enabled={true} />
                <HeaderFilter visible={true} allowSearch={true} />
              </DataGrid>
            </CustomGrid>
          </Card>
        </TabPanel>

        <TabPanel value="6" sx={{ px: 0 }}>
          <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
            <Button
              variant="contained"
              onClick={() => {
                let max = 0;
                actions.forEach((item) => {
                  const n = Number(item.ordem) || 0;
                  if (n > max) max = n;
                });
                CatalogModal('action', { acao: '', ordem: max + 1, sla: 1 });
              }}
              sx={{ mr: 1 }}
              startIcon={<Iconify icon="eva:plus-fill" />}>
              Novo
            </Button>
            {!isMobile && (
              <Button
                variant="outlined"
                onClick={getActions}
                sx={{ ml: 1 }}
                startIcon={<Iconify icon="eva:refresh-outline" />}>
                Atualizar
              </Button>
            )}
          </Stack>
          <Card>
            <CustomGrid>
              <DataGrid
                dataSource={actions}
                showBorders={true}
                remoteOperations={true}
                wordWrapEnabled={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                noDataText={'Não há ações cadastradas'}>
                <Column dataField="ordem" caption="Ordem" width={80} />
                <Column dataField="acao" caption="Ação" />
                <Column dataField="sla" caption="SLA (dias)" />
                <Column
                  dataField="Ações"
                  width={100}
                  allowSorting={false}
                  cellRender={(data) => (
                    <ActionsButtons
                      data={data}
                      type="action"
                      idKey="id_action"
                      deleteRouter="/leads/deleteAction"
                      deleteItem="a ação"
                      reload={getActions}
                    />
                  )}
                />
                <SearchPanel visible={true} width={240} placeholder="Procurar..." />
                {!isMobile && (
                  <GroupPanel
                    visible={true}
                    emptyPanelText="Arraste as colunas aqui para agrupar"
                  />
                )}
                <Scrolling rowRenderingMode="virtual"></Scrolling>
                <Paging defaultPageSize={10} />
                <Pager
                  visible={true}
                  allowedPageSizes={allowedPageSizes}
                  showPageSizeSelector={true}
                  showInfo={true}
                  showNavigationButtons={true}
                />
                <ColumnChooser
                  enabled={true}
                  title={'Escolher uma coluna'}
                  emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                />
                <ColumnFixing enabled={true} />
                <HeaderFilter visible={true} allowSearch={true} />
              </DataGrid>
            </CustomGrid>
          </Card>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default FormConfigPanel;
